import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useElementSize } from 'usehooks-ts';

import './StaticHeader.css';

interface StaticHeaderProps {
  className?: string;
  children: React.ReactNode;
}

export const StaticHeader: React.FC<React.PropsWithChildren<StaticHeaderProps>> = React.memo(
  ({ children, className = '' }) => {
    const [headerRef, { height: headerHeight }] = useElementSize();

    useEffect(() => {
      if (headerHeight) document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      return () => document.documentElement.style.setProperty('--header-height', '0px');
    }, [headerHeight]);

    const staticHeaderClassName = classNames({
      'static-header': true,
      [className]: className,
    });
    return (
      <header ref={headerRef} className={staticHeaderClassName}>
        {children}
      </header>
    );
  },
);
